<nav class="navbar navbar-top navbar-expand navbar-dashboard navbar-dark pl-0 pr-2 pb-0">
    <div class="container-fluid px-0">
        <div class="d-flex justify-content-between w-100" id="navbarSupportedContent">
            <div class="d-flex align-items-center">
            
            </div>
            <!-- Navbar links -->
            <ul class="navbar-nav align-items-center">
                <li class="nav-item dropdown">

                    <div class="media d-flex align-items-center">
                        <div class="media-body ml-2 text-dark align-items-center d-none d-lg-block">
                        <span class="mb-0 font-small font-weight-bold">{$stApp.user.login}</span>
                        </div>
                    </div>

                </li>
            </ul>
        </div>
    </div>
</nav>

<script>
    import {push} from 'svelte-spa-router'
    
    import {App, stApp} from '../dbclib/App.js'
</script>